import React, { useState } from "react";

import Modal from "react-bootstrap/Modal";
import "./css/login.css";
import SignIn from "./compoment/SignIn";
import SignUp from "./compoment/SignUp";

export default function ModalLogin(props) {
  const [redirect, setRedirect] = useState(false);

  const handleRedirect = () => setRedirect(prev => !prev);

  return (
    <div className="modal-login">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Body>
          <button className="close" onClick={props.onHide}>
            <i className="fas fa-times"></i>
          </button>
          <div className="container-login">
            {redirect ? (
              <SignUp onRedirect={handleRedirect} />
            ) : (
              <SignIn onRedirect={handleRedirect} />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
